<template>
  <div class="wrapper">
    <svgicon name="success" width="65" height="65" :original="true"></svgicon>
    <h1 class="title">Success</h1>
  </div>
</template>

<script>
import '../../assets/compiled-icons/index';

export default {
  name: 'Step5'
};
</script>

<style scoped>
.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: absolute;
}

/* Keyframes for the fade-in */
@keyframes fadeIn { from { opacity:0; } to { opacity:1; } }

/* Animation - svg appearance in 0.6s*/
svg {
  opacity: 0;
  animation: fadeIn ease-in 1;
  animation-fill-mode:forwards;
  animation-duration: 0.7s;
  animation-delay: 0.6s;
}

.title {
  margin: 9px 0 0 ;
  /* Animation - title appearance in 1s */
  opacity: 0;
  animation: fadeIn ease-in 1;
  animation-fill-mode: forwards;
  animation-duration: 0.7s;
  animation-delay: 1s;
}
</style>



// WEBPACK FOOTER //
// src/components/steps/Step5.vue